module.exports = __webpack_public_path__ + "static/media/0047.89777d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/RAL/0047.png
// module id = 1616
// module chunks = 0